export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-timer-line',
      title: 'Save Time',
      description: 'Stop browsing countless websites. Our curated Superbuy Spreadsheet organizes thousands of products across all major categories so you find what you need in seconds, not hours.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Find Products',
      description: 'Access a comprehensive database of products organized by category. From shoes and hoodies to bags and accessories, discover items you would have otherwise missed.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Compare Options',
      description: 'Make confident purchasing decisions by comparing products side by side. Understand features, pricing differences, and quality indicators before you buy.',
    },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-14">
      <div className="max-w-6xl mx-auto">
        <div className="mb-4">
          <span className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider whitespace-nowrap">Platform Features</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight max-w-2xl">
          Why Thousands Use<br />Superbuy Spreadsheet
        </h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-lg p-8 md:p-10 border border-background-200 hover:border-background-300 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-6">
                <i className={`${feat.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}